<template>
  <v-card class="mb-4">
    <!-- <v-progress-linear
      class="ma-auto"
      v-show="loading"
      :indeterminate="true"
    /> -->

    <v-toolbar dense>
      <v-toolbar-title>
        Payments
      </v-toolbar-title>
      <v-spacer />
      <edit-payment-button
        :personid="personId"
        :create-new="true"
        v-if="personId"
        @save="loadPayments"
      />
      <v-btn icon @click="loadPayments">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <div v-if="errors.length > 0">
      <v-alert v-for="message in errors" :key="message" type="error">
        {{ message }}
      </v-alert>
    </div>
    <v-data-table
      dense
      :items="payments"
      :headers="tableHeaders"
      item-key="batchitemid"
      :loading="loading"
      :options.sync="options"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.batchitemid }}</td>
          <td>{{ props.item.paymentreceiveddate | formatDate }}</td>
          <td>{{ props.item.paymentamount | currency }}</td>
          <td>{{ props.item.paymentref }}</td>
          <td>{{ lookup("FeeTypes", props.item.feetypeid) }}</td>
          <td>
            <edit-payment-button
              :personid="props.item.personId"
              :paymentid="props.item.batchitemid"
              :payment="props.item"
              @save="loadPayments"
            />
            <delete-item-button
              :itemid="props.item.batchitemid"
              url="financialbatchitems"
              @delete="loadPayments"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import moment from "moment";
import editPaymentButton from "./edit-payment-button";
import deleteItemButton from "@/components/lib/delete-item-button";
import { mapGetters } from "vuex";

export default {
  name: "PaymentList",
  data() {
    return {
      errors: [],
      options: {
        sortDesc: [true],
        sortBy: ["paymentreceiveddate"]
      },
      tableHeaders: [
        { text: "ID", value: "batchitemid" },
        { text: "Date", value: "paymentreceiveddate" },
        { text: "Amount", value: "paymentamount" },
        { text: "Reference", value: "paymentref" },
        { text: "Fee Type", value: "feetypeid" },
        { text: "", sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters({ lookup: "lookup", loading: "isLoading" }),
    payments() {
      return (
        this.$store.getters.getById(this.personId)?.practitioner?.payments || []
      );
    }
  },
  methods: {
    loadPayments() {
      if (!this.personId) {
        return;
      }
      this.$store.dispatch("load", this.personId);
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  props: {
    personId: String
  },
  watch: {
    personId: {
      handler: "loadPayments"
      // immediate: true
    }
  },
  filters: {
    currency(amount) {
      return "$" + amount;
    }
  },
  components: {
    "edit-payment-button": editPaymentButton,
    "delete-item-button": deleteItemButton
  }
};
</script>
